module.exports = __webpack_public_path__ + "static/orval-e98dbd436102faa05c7837735b0481d4.png";